import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import ScrollOut from "scroll-out";

const Person = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="인재상" eng="Human Resource"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <p class="tit-guide-sbj textC" data-scroll>
                        기본과 원칙을 지키고 열린 사고로 소통하는 <b>네트워크 전문가</b>
                    </p>

                    <div className="person-gray-wrap gray-back-bg" data-scroll>
                        <ul className="person-view-infos">
                            <li className="n01">
                                <div className="img_box"></div>
                                <div className="icon_box"></div>
                                <p className="sbj">
                                    <b>기본과 원칙</b>을 지키는 인재
                                </p>
                                <p className="text">
                                    고객의 이익과 만족을 최우선으로 생각하고 행동한다.
                                    <br />
                                    직업 윤리에 충실하며 맡은 일에 최선을 다한다.
                                </p>
                            </li>
                            <li className="n02">
                                <div className="img_box"></div>
                                <div className="icon_box"></div>
                                <p className="sbj">
                                    <b>열린 사고</b>로 소통하는 인재
                                </p>
                                <p className="text">
                                    창의성을 발휘해 변화와 혁신을 주도하여 차별화 된 서비스를 구현한다. <br />
                                    동료간 적극 소통하여 "즐겁고 신나는 일터"를 만드는 노력한다.
                                </p>
                            </li>
                            <li className="n03">
                                <div className="img_box"></div>
                                <div className="icon_box"></div>
                                <p className="sbj">
                                    <b>Global No.1</b> 네트워크 전문가
                                </p>
                                <p className="text">
                                    시련과 역경에 굴하지 않고 끊임없이 도전하여 최고의 네트워크 서비스를 제공한다.
                                    <br />
                                    급변하는 무한경쟁시대에서 Specialist가 되기 위해 노력한다.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Person;
